import * as toolbox from 'components/common/toolbox';
import React from 'react';
import _ from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ResultsActionIcons = (props) => {
    
    /* Hooks --------------------------*/
    
    const history = useHistory();
	const routeLocation = useLocation();

    const user = useSelector((store) => store.users.user);
    
    const entity = (props.workOrder) ? props.workOrder
        : (props.serviceRequest) ? props.serviceRequest
        : (props.quote) ? props.quote
        : (props.invoice) ? props.invoice
        : null;
        
    const openPhone = (event) => {
        event?.stopPropagation();
        let location = toolbox.modifyPath(routeLocation.pathname, 4, `action-form/${props.entity}/${props.entityId}/phone`, 7);
        history.push({ pathname: location });
    };
    const openSMS = (event) => {
        event?.stopPropagation();
        let location = toolbox.modifyPath(routeLocation.pathname, 4, `action-form/${props.entity}/${props.entityId}/sms`, 7);
        history.push({ pathname: location });
    };
   
    return (

        <div id="results-actions-icons" className={'d-flex nowrap'}>
            { entity?.technicianId && entity?.customerId && props.sms &&
                <a className="ml-2"><i className="fa-solid fa-mobile-screen " role="button" style={{ color: 'saddlebrown' }} onClick={ openSMS }></i></a>
            }
            { !!parseInt(entity?.customerId) &&
                <a><i className="fa-solid fa-phone " role="button" style={{ color: 'green' }} onClick={ openPhone }></i></a>
            }
            { entity?._address && user.contact?.appleMaps &&
                <a href={`https://maps.apple.com/place?q=${entity?._address}`} target="_blank"><i className="fa-solid fa-location-arrow" role="button" style={{ color: 'steelblue' }}></i></a>
            }
            { entity?._address && !user.contact?.appleMaps &&
                <a href={`https://www.google.com/maps/dir/?api=1&destination=${entity?._address}`} target="_blank" onClick={ (event) => event?.stopPropagation() }><i className="fa-solid fa-location-arrow" role="button" style={{ color: 'steelblue' }}></i></a>
            }
        </div>
    );
};

export default ResultsActionIcons;

